import { SearchHistoryContainer } from "./job-boards-search-history-infinite-scroll";
class JobBoardsSearchHistoryController {
    /*@ngInject*/
    constructor($rootScope, jobService, resumeService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.jobService = jobService;
        this.resumeService = resumeService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        //variables
        this.searchHistory = [];
        this.jobBoards = [];
        this.searchHistoryContainer = null;
        //flags
        this.isPanelOpen = [];
        this.isPanelOpen.push(true);
        this.getAllJobBoards(() => {
            this.searchHistoryContainer = new SearchHistoryContainer(this.jobId, this.jobBoards, this.jobService, this.alertsAndNotificationsService);
            this.searchHistoryContainer.searchHistoryQueryFilter = {
                pageNum: 1,
                size: 5
            };
        });
    }
    getAllJobBoards(successCallback) {
        this.resumeService.getAllSourceTypes((data) => {
            if (data.length > 0) {
                this.jobBoards = data;
                if (successCallback) {
                    successCallback();
                }
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getJobBoardsSearchHistory() {
        this.jobService.getJobBoardsSearchHistory(this.jobId, (data) => {
            this.searchHistory = data;
            this._parseSearch();
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error, 'danger');
            }
        });
    }
    _parseSearch() {
        angular.forEach(this.searchHistory, (search, key) => {
            search.jobBoards = angular.copy(this._addJobBoardDetails(search.jobBoardId, search.daxtraParameters));
            delete search.jobBoardId;
        });
        console.log('parsed search history');
        console.log(this.searchHistory);
    }
    _addJobBoardDetails(jobBoardIds, daxtraParameters) {
        let jobBoards = [];
        angular.forEach(jobBoardIds, (jobBoardId, key) => {
            let jobBoard = this.jobBoards.find((jobBoard) => {
                return jobBoard.id === jobBoardId;
            });
            //Parse daxtra params
            // jobBoard.allDaxtraParameters = angular.copy(_addDaxtraParametersToJobBoard(daxtraParameters, jobBoard.daxtraCode.toLowerCase()));
            // jobBoard.daxtraParameters = jobBoard.allDaxtraParameters.filter(function (param) {
            //     return param.value !== "";
            // });
            jobBoards.push(jobBoard);
        });
        return jobBoards;
    }
}
JobBoardsSearchHistoryController.$inject = ['$rootScope', 'jobService', 'resumeService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './job-boards-search-history.html';
import * as TEMPLATE from 'raw-loader!./job-boards-search-history.html';
export const JobBoardsSearchHistoryComponent = {
    selector: 'jobBoardsSearchHistory',
    component: {
        bindings: {
            jobId: '@',
            jobTitle: '@',
            clientOrBuName: '@'
        },
        controller: JobBoardsSearchHistoryController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/addCandidatesFromJobBoards/jobBoardsSupportedParameters/jobBoardsSearchHistory/job-boards-search-history.html'
    }
};
//# sourceMappingURL=job-boards-search-history.component.js.map